type Props = {
  name: string
  className?: string
}

export default function AvatarComponent({ name, className }: Props): JSX.Element {
  return name ? <div className={`avatar ${className || ''}`}>
    {name[0].toUpperCase()}
    </div> : null
}